import { isTwitter } from 'util/ticket'
import {
  doOpenNotePage,
  doOpenTicketPage,
  doOpenForwardPageExpanded,
} from 'actions/pages'

export function buildPageAction(
  ticketId,
  hasReply = false,
  hasNote = false,
  isForwarding = false,
  prefersExpandedReplyHeader = false
) {
  if (hasNote && !hasReply) return doOpenNotePage(ticketId)
  return isForwarding
    ? doOpenForwardPageExpanded(ticketId)
    : doOpenTicketPage(ticketId, { expand: prefersExpandedReplyHeader })
}

export function hasDraft(
  ticket,
  replyDraftBodyPlainText,
  noteDraftBodyPlainText
) {
  const isTwitterTicket = isTwitter(ticket)
  const replyDraftWithoutTwitterHandle =
    replyDraftBodyPlainText &&
    replyDraftBodyPlainText.replace(/^@[^\s]*\s?/, '').trim()

  const hasReplyDraft =
    (isTwitterTicket && replyDraftWithoutTwitterHandle) ||
    (!isTwitterTicket && replyDraftBodyPlainText)

  return hasReplyDraft || noteDraftBodyPlainText
}

export function getSnippet(
  ticket,
  replyDraftBodyPlainText,
  noteDraftBodyPlainText
) {
  const draftPresent = hasDraft(
    ticket,
    replyDraftBodyPlainText,
    noteDraftBodyPlainText
  )

  let snippet = null
  if (draftPresent && replyDraftBodyPlainText) {
    snippet = {
      type: 'reply',
      text: replyDraftBodyPlainText,
    }
  } else if (draftPresent && noteDraftBodyPlainText) {
    snippet = {
      type: 'internal',
      text: noteDraftBodyPlainText,
    }
  } else {
    snippet = {
      type: ticket.bodyType || 'enduser',
      text: ticket.body,
    }
  }

  return snippet
}

export function lastMessageWasLeftByAgent(ticket) {
  return ticket && ticket.bodyAuthor && ticket.bodyAuthor.type === 'Agent'
}

export function lastMessageIsANote(ticket) {
  return (
    ticket &&
    ticket.bodyType === 'internal' &&
    ticket.bodyAuthor &&
    ticket.bodyAuthor.type === 'Agent'
  )
}
